/** @format */

import CommonModal from 'components/Modals/CommonModal';
import config from 'config';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logoutRequestAction, updateActiveIndex } from 'stateContainer/actions';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOut } from '@fortawesome/free-solid-svg-icons';

import './styles.scss';

export default function LeftNavBar({
  logOutModalText: { header, body, button_1, button_2 },
  leftBarNavText,
  setShow
}) {
  const {
    activeNav: { index }
  } = useSelector((state) => state);
  const { requesting, data } = useSelector((state) => state.session);

  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const userName = data.userData?.brokerName || '';
  const userEmail = data.userData?.fmEmail || '';
  const slug = data.userData?.brokerSlug || '';
  const profilePicture =
    data.userData?.image || '../images/image-profile-pic.svg';

  const Logout = () => (
    <div className='dashboard-logout-container'>
      <button className='btn btn-white' onClick={() => handleShow()}>
        <FontAwesomeIcon icon={faSignOut} size='sm' />
        <p className='text1r'>{leftBarNavText.logout}</p>
      </button>
    </div>
  );

  const BrokerInfo = () => (
    <div className='dashboard-nav-profile-container'>
      <img src={profilePicture} alt={userName} />
      <div className='dashboard-profile-text'>
        <p className='text2m' id='broker-name'>
          {userName}
        </p>
        <p className='text3r'>{userEmail}</p>
      </div>
    </div>
  );

  return (
    <div className='dashboard-nav-container'>
      <div>
        <img
          src='../images/image-main-logo.svg'
          alt='Main logo'
          className='dashbord-header-image'
        />
        <div>
          <p className='text2m'>{leftBarNavText.main_menu.heading}</p>
          <div className='dashboard-nav-menu'>
            <div
              className={`dashboard-nav-buttons ${
                index === 0 && 'dashboard-nav-active-bar'
              }`}
              onClick={() => {
                dispatch(updateActiveIndex(0));
                setShow(false);
              }}>
              <img
                src='../images/image-dashboard.svg'
                className={`${
                  index === 0
                    ? 'dashboard-nav-active-img'
                    : 'dashboard-nav-inactive-img'
                }`}
              />
              <div className='text1r'>
                {leftBarNavText.main_menu.menu_item_1}
              </div>
            </div>
            <div
              className={`dashboard-nav-buttons ${
                index === 1 && 'dashboard-nav-active-bar'
              }`}
              onClick={() => {
                dispatch(updateActiveIndex(1));
                setShow(false);
              }}>
              <img
                src='../images/image-brokers.svg'
                className={`${
                  index === 1
                    ? 'dashboard-nav-active-img'
                    : 'dashboard-nav-inactive-img'
                }`}
              />
              <div className='text1r'>
                {leftBarNavText.main_menu.menu_item_2}
              </div>
            </div>
            <div className={`dashboard-nav-buttons public-profile-button`}>
              <button
                onClick={() => {
                  window.open(
                    `${config.app.friaMaklareWebOriginUrl}/${slug}`,
                    '_blank'
                  );
                }}>
                <img
                  src='../images/image-public-profile.svg'
                  className={`dashboard-nav-inactive-img`}
                />
                <div className='text1r'>
                  {leftBarNavText.main_menu.public_profile}
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div>
        <p className='text2m'>{leftBarNavText.support_menu.heading}</p>
        <div className='dashboard-phone-number dashboard-nav-menu'>
          <img src='../images/image-email.svg' />
          <p className='text1r'>{leftBarNavText.support_menu.menu_item_1}</p>
        </div>

        <div className='dashboard-phone-number'>
          <img src='../images/image-whatsapp.svg' />
          <p className='text1r'>{leftBarNavText.support_menu.menu_item_2}</p>
        </div>
      </div>
      <div>
        <BrokerInfo />
        <Logout />
      </div>
      <CommonModal
        handleClose={handleClose}
        showModal={showModal}
        header={header}
        body={body}
        button_1={button_1}
        button_2={button_2}
        loading={requesting}
        centerButtons
        handleBtn1={() => {
          dispatch(logoutRequestAction());
        }}
        handleBtn2={() => handleClose()}
      />
    </div>
  );
}
